<template>
  <!-- 动态加载组件 -->
  <component :pulldata="data" :is="isComponent"></component>
</template>
<script>
import {
  getproject,
} from "@/api/course";
import { isMain,getSessionStorage } from '@/utils/tools'
import { newCourse } from '@/utils/course'
import list1 from "@/views/course/list/list1"
import list2 from "@/views/course/list/list2"
import list2_2 from "@/views/course/list/list2_2"

export default {
  data() {
      return {
        cid: null,
        data: {},
        isComponent:''
      }
    },
    components: {
      list1,
      list2,
      list2_2
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let querys = this.$route.query;
        this.cid = parseInt(querys.cid, 10);

        if(isMain() && this.cid<=4){
            location.href = "https://api.xjy.cn/tools/career/course/list.html?cid=" + this.cid;
            return;
        }

        getproject({
            cid: this.cid
          })
          .then((data) => {
            this.$toast.clear();
            this.data = data;
            document.title = data.bigCourseName;

            // 判断是哪一个课（bid为1或2）
            if(data.bid===2 || getSessionStorage('request','/bid') && getSessionStorage('request','/bid')==2){
              // 上线判断
              if(!isMain() || newCourse(this.cid)) {
                this.isComponent = list2_2;
              }else{
                this.isComponent = list2;
              }
            }else{
              this.isComponent = list1;
            }
          })
      }
    },
    created() {
      this.pullData();
    },
}
</script>